import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import { formattedDate } from "../DateUtils";
import { postActionDataRefresh } from "../CommonUtils";
import DatatTable from "../Table";
import { IconButton, Tab } from "@mui/material";
import ShowDataTable from "../Tables/ShowDataTable";
import { Close as CloseIcon } from "@mui/icons-material";
import Timer from "../../basic-component/Timer";
import Card from "react-bootstrap/Card";
import styles from "../../basic-component/form-component/feedback-form/ViewFeedbackDetails.module.css";
import {
  acceptFeedbackAfterOnClickURL,
  acceptFeedbackURL,
  apiHostUrl,
} from "../../../../constants/constants";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import { useSelector, useDispatch } from "react-redux";
import { setResponsePendingReducer } from "../../../system/redux/reducers/ResponsePendingReducer";
// import useAddModal from '../../../../hooks/useAddModal';
import Snackbar from "@mui/material/Snackbar";

// Bootstrap
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";

export default function AcceptFeedbackModalBody({
  open,
  handleClose,
  val,
  onClose,
  setSnackBarSwitch,
  setSnackBarMessage,
  onModalCloseHandler,
}) {
  const { i18n, t } = useTranslation();
  const [timer, setTimer] = useState(10);
  // console.log(val[0]);
  // console.log(val[1]);
  const [lastopen, setLastOpen] = useState(false);
  // const { isOpen, val, toggleModal } = useAddModal();
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector(
    (state) => state.csrf
  );
  const [payload, setPayload] = useState(null);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const { homeLink } = useSelector((state) => state.role);
  const columnData = [
    t("feedbackDetails.step.text"),
    t("menu.key.master.group.name"),
    t("menu.key.master.targettime"),
  ];
  const columnData1 = [
    t("feedbackDetails.level.text"),
    t("menu.key.master.group.name"),
    t("menu.key.master.targettime"),
  ];

  const rowsData = val[0].departmentSlaAssignmentList.map((item, index) => [
    item.step,
    item.assigneeGroupName,
    formattedDate(item.targetTime),
  ]);
  const rowsData1 = val[0].departmentSlaEscalationList
    .filter((ele) => ele.escalationStep !== 0)
    .map((item, index) => [
      item.escalationStep,
      item.assigneeGroupName,
      formattedDate(item.escTime),
    ]);

  const dispatch = useDispatch();
  const { acceptFeedbackOnSubmit } = useSelector(
    (state) => state.ResponsePendingReducer
  );
  const handleCancelClick = () => {
    onModalCloseHandler();
  };
  const handleTimerUpdate = (newTime) => {
    if (newTime <= 0 && !acceptFeedbackOnSubmit) {
      handleClose();
      onModalCloseHandler();
    } else {
      setTimer(newTime);
    }
  };
  const generateAppropriateDate = (value) => {
    const date = new Date(value);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate =
      [
        ("0" + date.getDate()).slice(-2), // Day
        ("0" + (date.getMonth() + 1)).slice(-2), // Month
        date.getFullYear(), // Year
      ].join("-") +
      " " +
      date.toLocaleTimeString("en-US", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
      });

    return formattedDate;
  };

  const { fetchData: fetchAcceptData } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${acceptFeedbackURL}`,
    method: "post",
    body: payload,
    headers: headers,
    onLoad: false,
  });
  const passPayload = (vall) => {
    const tempData = {
      departmentId: String(vall[1].departmentId),
      feedbackId: String(vall[1].feedbackId),
      latestReceipt: {
        assignmentTime: generateAppropriateDate(
          vall[0].departmentSlaAssignment.targetTime
        ),
        departmentSlaEscalationList: vall[0].departmentSlaEscalationList.map(
          (entry) => ({
            escalationStep: String(entry.escalationStep),
            escalationTime: generateAppropriateDate(entry.escTime),
            departmentSlaEscalationId: String(entry.departmentSlaEscalationId),
          })
        ),
        receiptTargetId: String(vall[1].receipts[0].receiptTargetId),
        warningTime_str: generateAppropriateDate(vall[0].warningTime),
      },
    };
    return tempData;
  };
  useEffect(() => {
    val && setPayload(passPayload(val));
  }, [val]);

  const lasthandleClose = () => {
    setLastOpen(false);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={lasthandleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  const handleOnAccept = () => {
    dispatch(setResponsePendingReducer({ acceptFeedbackOnSubmit: true }));
    fetchAcceptData().then((data) => {
      dispatch(setResponsePendingReducer({ acceptFeedbackOnSubmit: false }));
      console.log(data);
      if (data) {
        setSnackBarSwitch(true);
        setSnackBarMessage(t("general.label.msg.addReceiptSuccess"));
      }

      onModalCloseHandler();

      setTimeout(() => {
        postActionDataRefresh(3, null);
      }, 100);

      onClose(t("general.label.msg.addReceiptSuccess"));
    });
  };
  return (
    // <Modal open={open} onClose={handleClose} val={val}>
    // <Box sx={{
    //     position: 'absolute', top: '50%', left: '50%', overflowY: 'auto', overflowX: 'none',
    //     transform: 'translate(-50%, -50%)', width: "80%", height: "95%", bgcolor: 'background.paper',
    //     border: '2px solid #000', p: 2, borderRadius: '25px'
    // }}>
    //     <Box display="flex" justifyContent="flex-end">
    //         <IconButton onClick={handleClose} size="small">
    //             <CloseIcon />
    //         </IconButton>
    //     </Box>

    <Row>
      <Timer
        text={t("general.lable.acceptReceipt")}
        countdown={timer}
        onTimerUpdate={handleTimerUpdate}
        sec={t("general.lable.acceptReceiptTime")}
      />
      <Col lg="12">
        <Card className="mb-3 overflow-hidden">
          <Card.Header className="light-blue-bg fw-medium">
            {t("general.lable.resolutionTargetTime")}
          </Card.Header>
          <Card.Body className="p-0">
            <ShowDataTable columns={columnData} rows={rowsData} />
          </Card.Body>
        </Card>
      </Col>

      <Col lg="12">
        <Card className="mb-3 overflow-hidden">
          <Card.Header className="light-blue-bg fw-medium">
            {t("feedbackDetails.escalationMatrix.text")}
          </Card.Header>
          <Card.Body className="p-0">
            <ShowDataTable columns={columnData1} rows={rowsData1} />
          </Card.Body>
        </Card>
      </Col>
      <Col lg="12" className="text-end">
        <Button
          variant="outline-dark"
          className="ms-2"
          onClick={handleCancelClick}
          disabled={acceptFeedbackOnSubmit}
        >
          {t("general.button.cancel.label")}
        </Button>
        <Button
          variant="primary"
          className="ms-2"
          onClick={handleOnAccept}
          disabled={acceptFeedbackOnSubmit}
        >
          {t("general.button.accept")}{" "}
          {acceptFeedbackOnSubmit && (
            <span className="spinner-border spinner-border-sm ml-2"></span>
          )}
        </Button>
      </Col>
    </Row>

    // </Box>
    // </Modal>
  );
}
